// TransferHistory.js
import React from "react";
import { Timeline, Tag, Card, Typography, Spin } from "antd";
import { 
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  SwapOutlined
} from "@ant-design/icons";

import { formatDate, formatUser } from "../../../lib/utils";

const { Text } = Typography;

const TransferHistory = ({ transferHistory, transferHistoryLoading }) => {
  const getStatusConfig = (estado) => {
    switch (estado?.toLowerCase()) {
      case 'iniciado':
        return {
          icon: <LoadingOutlined />,
          color: 'processing',
          text: 'Iniciado'
        };
      case 'aceptado':
        return {
          icon: <CheckCircleOutlined />,
          color: 'success',
          text: 'Aceptado'
        };
      case 'anulado':
        return {
          icon: <CloseCircleOutlined />,
          color: 'error',
          text: 'Anulado'
        };
      default:
        return {
          icon: <SwapOutlined />,
          color: 'default',
          text: estado || 'N/A'
        };
    }
  };

  if (transferHistoryLoading) {
    return <Spin size="large" />;
  }

  if (!transferHistory || transferHistory.length === 0) {
    return <Text type="secondary">No hay historial de traslados disponible</Text>;
  }

  return (
    <Card>
      <Timeline mode="left">
        {transferHistory.map((historial, index) => {
          const { icon, color, text } = getStatusConfig(historial.estado);
          return (
            <Timeline.Item
              key={index}
              dot={icon}
              color={color}
            >
              <Card size="small" style={{ marginBottom: 16 }}>
                <div style={{ marginBottom: 8 }}>
                  <Tag color={color}>{text}</Tag>
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                  <Text type="secondary">
                    Bodega salida: {historial.bodega_salida?.nombre || "N/A"}
                  </Text>
                  <Text type="secondary">
                    Bodega destino: {historial.bodega_destino?.nombre || "N/A"}
                  </Text>
                  
                  {historial.acaptado_por && (
                    <Text type="secondary">
                      Aceptado por: {historial.acaptado_por.first_name}
                    </Text>
                  )}
                  
                  {historial.aceptado_fecha && (
                    <Text type="secondary">
                      Fecha aceptación: {formatDate(historial.aceptado_fecha)}
                    </Text>
                  )}
                  
                  {historial.anulado_por && (
                    <Text type="secondary" style={{ gridColumn: '1 / -1' }}>
                      Anulado por: {formatUser(historial.anulado_por)}
                    </Text>
                  )}
                </div>

                <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                  Creado: {formatDate(historial.date_created)}
                </Text>
              </Card>
            </Timeline.Item>
          );
        })}
      </Timeline>
    </Card>
  );
};

export default TransferHistory;